var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5,77.3c0-0.867,0.316-1.6,0.95-2.2c0.6-0.6,1.35-0.9,2.25-0.9h83.7  c0.866,0,1.6,0.3,2.199,0.9c0.601,0.6,0.9,1.333,0.9,2.2v14.5c0,0.9-0.3,1.65-0.9,2.25c-0.6,0.6-1.333,0.9-2.199,0.9V95H8.2v-0.05  c-0.9,0-1.65-0.3-2.25-0.9c-0.601-0.6-0.9-1.35-0.9-2.25V77.45L5,77.3z M91.9,5c0.866,0,1.6,0.3,2.199,0.9C94.7,6.5,95,7.233,95,8.1  v14.5c0,0.9-0.3,1.65-0.9,2.25c-0.6,0.6-1.333,0.9-2.199,0.9H8.2c-0.9,0-1.65-0.3-2.25-0.9c-0.601-0.6-0.9-1.35-0.9-2.25V8.25L5,8.1  c0-0.867,0.316-1.6,0.95-2.2C6.55,5.3,7.3,5,8.2,5H91.9z M94.1,40.5c0.601,0.6,0.9,1.333,0.9,2.2v14.5c0,0.9-0.3,1.65-0.9,2.25  c-0.6,0.6-1.333,0.9-2.199,0.9H8.2c-0.9,0-1.65-0.3-2.25-0.9c-0.601-0.6-0.9-1.35-0.9-2.25V42.85L5,42.7c0-0.867,0.316-1.6,0.95-2.2  c0.6-0.6,1.35-0.9,2.25-0.9h83.7C92.767,39.6,93.5,39.9,94.1,40.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.5624db792129040aabe8b7717f3aad74.svg";
export { ForwardRef as ReactComponent };